import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import Styles from './style.module.scss';
import withComponentName from '../../../../../../../decorators/withComponentName';

const cx = classNames.bind(Styles);

export const PricingPlansFilterPlanButton = ({
  isActive, btnText, handleBtnClick, btnID,
}) => (
  <button
    id={btnID}
    type="button"
    className={cx('PricingPlans__btn', { active: isActive }, { [`${btnID}`]: true })}
    onClick={() => handleBtnClick(btnID)}
  >
    {btnText}
  </button>
);

PricingPlansFilterPlanButton.propTypes = {
  isActive: PropTypes.bool.isRequired,
  btnText: PropTypes.string.isRequired,
  btnID: PropTypes.string.isRequired,
  handleBtnClick: PropTypes.func.isRequired,
};

export default withComponentName(PricingPlansFilterPlanButton);
